(function() {
    'use strict';

    angular.module('app').factory('GuideService', GuideService);

    GuideService.$inject = ['$cookies'];

    function GuideService($cookies) {
        function doesCookieExists() {
            return $cookies.get('guide-cookie-clear') !== void 0;
        }

        function setCookie() {
            var seconds = 60 * 60 * 24 * 7;

            var expires = new Date();
            expires = new Date(expires.getTime() + 1000 * seconds);

            $cookies.put('guide-cookie-clear', 1, {
                expires: expires,
            });
        }

        function visit(url) {
            setCookie();
            location.href = url;
        }

        function close() {
            setCookie();
        }

        return {
            doesCookieExists: doesCookieExists,
            visit: visit,
            close: close,
        };
    }
})();
